import { render, staticRenderFns } from "./VehicleDetail.vue?vue&type=template&id=7917a3b1&lang=pug&"
import script from "./VehicleDetail.vue?vue&type=script&lang=ts&"
export * from "./VehicleDetail.vue?vue&type=script&lang=ts&"
import style0 from "./VehicleDetail.vue?vue&type=style&index=0&id=7917a3b1&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports